export const isFieldRequired = (field, requiredFields = []) => requiredFields.includes(field);
//# sourceMappingURL=registerFields.config.js.map